import { useGetMeQuery } from '@/services/qchinesepokerApi';

/**
 * Chi sono io per QChinesePoker (`chinesepoker.me.read`, I-646): lo `User.id` delle righe di QCP, o `null`. UN solo punto che lo dice
 * (X4 di tma-orcb): storico, replay, classifica e fine partita leggono da qui, e il posto lo decide `postoMio` (`lib/qcp/rest.ts`).
 * ⛔ `me` e' ACCESSORIO: caricamento, `hasProfile:false`, 424, un altro `code`, rete giu', forma rotta sono TUTTI `null`, e `null` lascia le
 * schermate com'erano prima. Per costruzione il hook non espone mai l'errore: non c'e' modo di farne un errore di schermata.
 */
export function useQcpMe(): string | null {
  const { data } = useGetMeQuery();
  return data?.userId ?? null;
}
